import { render, staticRenderFns } from "./MaterialsPlan.vue?vue&type=template&id=9f673798"
import script from "./MaterialsPlan.vue?vue&type=script&lang=js"
export * from "./MaterialsPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports